import { useState, useEffect } from 'react'
import classnames from 'classnames'

export const TreeMenu = (props) => {
  const [items, setItems] = useState([])

  useEffect(() => { setItems(JSON.parse(props.json)) }, [])

  return items.length ? <Menu items={items} highlight={props.highlight} /> : null
}

// view at app/views/layouts/orga_manage.html.slim#36
// items via app/lib/manage/menu/organisation_serializer.rb and files of this folder
const Menu = ({items, parentActive, parentChildActive, parentChildActivate, highlight}) => {
  const [activeItem, setActiveItem] = useState(null)
  const [childActiveItem, setChildActiveItem] = useState(null)
  const [expandedItem, setExpandedItem] = useState(null)
  const itemActivated = (index) => {
    setActiveItem(index)
    setChildActiveItem(null)
    parentChildActivate && parentChildActivate()
  }
  const itemChildActivated = (index) => {
    setChildActiveItem(index)
    setActiveItem(null)
    parentChildActivate && parentChildActivate()
  }

  useEffect(() => {
    if (highlight && items.filter(item => item.identifier === highlight).length) {
      itemActivated(highlight)
    }
  }, [])

  // Set everything inside inactive if parent says so.
  if (parentActive || parentChildActive === false) {
    if (activeItem) setActiveItem(null)
    if (childActiveItem) setChildActiveItem(null)
  }

  return <ol>
    {items && items.map((item) => <Item
      {...item}
      key={item.identifier}
      active={activeItem === item.identifier}
      childActive={childActiveItem === item.identifier}
      activate={() => itemActivated(item.identifier)}
      childActivate={() => itemChildActivated(item.identifier)}
      highlight={highlight}
      expanded={item.identifier === expandedItem}
      expand={(bool) => setExpandedItem(bool && item.identifier)}
    />)}
  </ol>
}

const Item = (props) => {
  const [subitems, setSubitems] = useState(props.submenu && props.submenu.items)
  const submenuUrl = props.submenu && props.submenu.url
  const hasSubmenu = !!(subitems || submenuUrl)

  // Auto-open active branch.
  useEffect(() => { if (props.active || props.childActive) props.expand(true) }, [props.active, props.childActive])

  useEffect(() => {
    if (submenuUrl && props.expanded) {
      fetch(submenuUrl).then(response => {
        response.json().then(info => setSubitems(info.submenu.items))
      })
    }
  }, [props.expanded])

  const toggleFold = () => props.expand(!props.expanded)

  const mods = props.modifiers || []

  let disabled = mods.includes('disabled')

  let classNames = classnames(props.className, 'module-tree-menu__item', {
    ['module-tree-menu__item--collapsed']: !props.expanded,
    ['module-tree-menu__item--expanded']: props.expanded,
    ['module-tree-menu__item--active']: props.active,
    ['module-tree-menu__item--child-active']: props.childActive,
    ['module-tree-menu__item--disabled']: disabled,
    ['module-tree-menu__item--completed']: mods.includes('completed'),
    ['module-tree-menu__item--checkmarked']: mods.includes('checkmarked'),
    ['module-tree-menu__item--placeholder']: mods.includes('placeholder'),
  })

  let tooltip = props.identifier.includes('organisation')
    ? I18n.t('manage.organisations.menu.organisation_blocked_hint')
    : I18n.t('manage.organisations.menu.project_blocked_hint')

  return <li className={classNames}>
    <div className='module-tree-menu__item__label' onClick={ disabled ? null : toggleFold} title={disabled ? tooltip : null}>
      {mods.includes('blocked') ? <span className='module-tree-menu__item--blocked-label'>{I18n.t('manage.organisations.menu.project_blocked_label')}</span> : ''}
      {mods.includes('preparing') ? <span className='module-tree-menu__item--preparing-label'>{I18n.t('manage.organisations.menu.project_preparing_label')}</span> : ''}
      {mods.includes('proposed') ? <span className='module-tree-menu__item--proposed-label'>{I18n.t('manage.organisations.menu.project_proposed_label')}</span> : ''}
      {disabled ? props.label : <a href={props.href}>{props.label}</a>}
      {hasSubmenu && <i className={`ml-2 fa fa-angle-right module-tree-menu__item__toggle ${props.expanded ? ('module-tree-menu__item__toggle--expanded') : ''}`} onClick={toggleFold} />}
    </div>
    {hasSubmenu && <Menu items={subitems} parentActive={props.active} parentChildActive={props.childActive} parentChildActivate={props.childActivate} highlight={props.highlight} />}
  </li>
}
